export default "__VITE_ASSET__6ea889e9__"